<template>
    <v-form ref="form">
        <v-row no-gutters class="mt-4 h-100">
            <v-col cols="3" class="px-2">
                <v-text-field
                    label="Desconto (%)"
                    v-model="descontoCampo.percentual"
                    class="input-cinza"
                    outlined
                    dense
                    v-mask="'###'"
                    :disabled="isUsuarioMarcasProprias()"
                ></v-text-field>
            </v-col>
            <v-col cols="3" class="px-2">
                <vuetify-money
                    label="Desconto (R$)"
                    v-model="descontoCampo.desconto"
                    class="input-cinza"
                    outlined
                    dense
                    backgroundColor=""
                    :disabled="isUsuarioMarcasProprias()"
                />
            </v-col>
            <v-col cols="3" class="px-2">
                <v-btn
                    class="ml-2 mb-1 new-button"
                    color="primary"
                    :disabled="isUsuarioMarcasProprias()"
                    @click="carregarDesconto()"
                >
                    <v-icon left>mdi-arrow-down</v-icon> Carregar Desconto
                </v-btn>
            </v-col>
            <v-col
                cols="12"
                sm="12"
                md="2"
                class="pt-0 mt-0 d-flex"
                justify="center"
				v-if="mostrarPreAcordo"
            >
			<div class="d-flex"                     
 >
            
                    <InfoBox class="mt-1"  >
                        <p>
							Caso deseje prosseguir com o acordo, mas ainda não possui as informações sobre os produtos, ative o Pré acordo ao lado.
                        </p></InfoBox
                    >

					<v-checkbox
                    class="flag-pre-acordo  ml-2"
                    v-model="value.preAcordo"
                    :disabled="isUsuarioMarcasProprias()"
                    label="Pré acordo"
                    dark
					
                >
                </v-checkbox>
                </div>
            </v-col>
        </v-row>
        <v-data-table
            :headers="listaHeaderDesconto"
            :items="desconto"
            :item-class="investimentoClass"
            item-key="nome"
            class="elevation-0 tabela"
            hide-default-footer
            disable-sort
            :items-per-page="-1"

        >
            <!-- <template v-slot:[`item.percentual`]="{ item }">
                <v-text-field
                    v-if="item.mes != 'Total'"
                    :ripple="false"
                    dense
                    outlined
                    hide-details
                    v-mask="'###'"
                    v-model="item.percentual"
                    @input="calculaDesconto()"
                ></v-text-field>
            </template> -->
            <template v-slot:[`item.custo`]="{ item }">
                <vuetify-money
                    v-if="item.mes != 'Total'"
                    :ripple="false"
                    dense
                    outlined
                    hide-details
                    v-model="item.custo"
                    class="input-cinza"
                    @input="calculaDesconto()"
                    :disabled="isUsuarioMarcasProprias()"
                />
                <span v-else>
                  <!-- Sempre mostra o custo da primeira linha editável -->
                  {{ desconto.length > 1 ? desconto[0].custo : 'R$ 0,00' }}
                </span>
            </template>
            <template v-slot:[`item.percentual`]="{ item }">
                <v-text-field
                    v-if="item.mes != 'Total'"
                    :ripple="false"
                    dense
                    outlined
                    hide-details
                    v-mask="'###'"
                    class="input-cinza"
                    v-model="item.percentual"
                    @input="calculaDesconto()"
                    :disabled="isUsuarioMarcasProprias()"
                ></v-text-field>
                <span v-else>{{ item.percentual }}%</span>
            </template>
            <!-- <template v-slot:[`item.desconto`]="{ item }">
                <vuetify-money
                    v-if="item.mes != 'Total'"
                    :ripple="false"
                    dense
                    outlined
                    hide-details
                    v-model="item.desconto"
                    backgroundColor=""
                    @input="calculaDesconto()"
                />
            </template> -->
            <template v-slot:[`item.desconto`]="{ item }">
                <vuetify-money
                    v-if="item.mes != 'Total'"
                    :ripple="false"
                    dense
                    outlined
                    hide-details
                    v-model="item.desconto"
                    class="input-cinza"
                    @input="calculaDesconto()"
                    :disabled="isUsuarioMarcasProprias()"
                />
                <span v-else></span>
            </template>
            <template v-slot:[`item.justificativas`]="{ item }">
                <v-select
                    required
                    placeholder="Justificativa"
                    v-model="item.justificativa"
                    :rules="regras.justificativa"
                    :items="justificativas"
                    item-text="justificativa"
                    item-value="id_justificativa"
                    dense
                    outlined
                    hide-details
                    @change="atualizaDescontos(item)"
                    class="input-cinza"
                    :menu-props="menuProps"
                    :disabled="isUsuarioMarcasProprias()"
                    v-if="
                        ((item.percentual != '' &&
                            item.percentual != undefined) ||
                            (item.desconto != '' &&
                                item.desconto != undefined &&
                                item.desconto != 0)) &&
                        item.mes != 'Total'
                    "
                ></v-select>
                <span v-else-if="item.mes != 'Total'">{{ showJustificativa(item.id_justificativa) }}</span>
            </template>
        </v-data-table>

        <v-row no-gutters class="mt-4" v-if="desconto.length > 0">
            <v-col cols="12">
                <v-alert v-if="alertaNeogrupoNull" type="warning" text border="left" class="mb-2">
                    Este fornecedor não possui configuração de Neogrupo cadastrada. Preencha os percentuais manualmente.
                </v-alert>
                <v-alert v-if="erroNeogrupoSoma" type="error" text border="left" class="mb-2">
                    A soma dos percentuais OTC + Perfumaria + RX deve ser exatamente 100%. Atualmente: {{ somaNeogrupo }}%.
                </v-alert>
            </v-col>
            <v-col cols="12" class="mb-4">
                <strong>Participação Neogrupo</strong>
            </v-col>
            <v-col cols="4" class="px-2">
                <vuetify-money
                    label="% OTC"
                    v-model="neogrupo.perc_otc"
                    class="input-neogrupo"
                    outlined
                    dense
                    backgroundColor=""
                    :disabled="isUsuarioMarcasProprias()"
                    :error="erroNeogrupoSoma"
                    @input="calculaNeogrupoPreview()"
                />
            </v-col>
            <v-col cols="4" class="px-2">
                <vuetify-money
                    label="% Perfumaria"
                    v-model="neogrupo.perc_perfumaria"
                    class="input-neogrupo"
                    outlined
                    dense
                    backgroundColor=""
                    :disabled="isUsuarioMarcasProprias()"
                    :error="erroNeogrupoSoma"
                    @input="calculaNeogrupoPreview()"
                />
            </v-col>
            <v-col cols="4" class="px-2">
                <vuetify-money
                    label="% RX"
                    v-model="neogrupo.perc_rx"
                    class="input-neogrupo"
                    outlined
                    dense
                    backgroundColor=""
                    :disabled="isUsuarioMarcasProprias()"
                    :error="erroNeogrupoSoma"
                    @input="calculaNeogrupoPreview()"
                />
            </v-col>
        </v-row>

        <v-simple-table v-if="neogrupoPreview && desconto.length > 0" dense class="mt-2 mb-4">
            <template v-slot:default>
                <thead>
                    <tr>
                        <th class="text-center">Neogrupo</th>
                        <th class="text-center">% Participação</th>
                        <th class="text-center">Valor (R$)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="text-center">OTC</td>
                        <td class="text-center">{{ neogrupo.perc_otc || 0 }}%</td>
                        <td class="text-center">{{ neogrupoPreview.valor_otc }}</td>
                    </tr>
                    <tr>
                        <td class="text-center">Perfumaria</td>
                        <td class="text-center">{{ neogrupo.perc_perfumaria || 0 }}%</td>
                        <td class="text-center">{{ neogrupoPreview.valor_perfumaria }}</td>
                    </tr>
                    <tr>
                        <td class="text-center">RX</td>
                        <td class="text-center">{{ neogrupo.perc_rx || 0 }}%</td>
                        <td class="text-center">{{ neogrupoPreview.valor_rx }}</td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>

        <div v-if="false" class="dialogo-erro" width="700px">
            <v-card class="br-15">
                <v-toolbar
                    elevation="0"
                    dark
                    class="error white--text fix-flex"
                >
                    <v-toolbar-title>
                        Por favor retorne as etapas anteriores e preencha os
                        seguintes campos:</v-toolbar-title
                    >
                </v-toolbar>
                <v-card-text class="pa-5">
                    <v-list>
                        <v-list-item>
                            <v-list-item-content>
                                <p>{{ dialogoCamposFaltandoMensagem }}</p>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card-text>
            </v-card>
        </div>
        <!-- <v-btn class="ml-2 mb-1 new-button" color="primary" @click="validate()">
            <v-icon left>mdi-arrow-down</v-icon> Valida
        </v-btn> -->

        <v-overlay :value="carregando">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-overlay
            :value="semAcesso"
            :absolute="true"
            :opacity="0.1"
            :z-index="3"
        ></v-overlay>
        <v-overlay
            :value="mostraOverlay"
            :absolute="true"
            :opacity="0.6"
            :z-index="3"
        ></v-overlay>
    </v-form>
</template>

<script>
import useUsuario from '@/hooks/useUsuario';

export default {
    name: 'abaDesconto',
    props: ["value", "preacordo"],
    setup(){
        const { isUsuarioMarcasProprias } = useUsuario();
        return {
            isUsuarioMarcasProprias
        }
    },
    data() {
        return {
            menuProps: {
                bottom: true,
                offsetY: true,
                contentClass: "select-outline",
                transition: "slide-y-transition",
            },
            acordo: {},
            somaFiliais: [],
            somaFiliaisValor: [],
            dialogoCamposFaltando: false,
            dialogoCamposFaltandoMensagem: "",
            desconto: [],
            neogrupo: {
                perc_otc: null,
                perc_perfumaria: null,
                perc_rx: null,
            },
            neogrupoPreview: null,
            alertaNeogrupoNull: false,
            descontoCampo: {
                percentual: null,
                desconto: null,
            },
            regras: {
                justificativa: [
                    (v) => !!v || "O campo justificativa é obrigatório",
                ],
            },
            listaHeaderDesconto: [
                {
                    text: "Mês",
                    value: "mes",
                    align: "center",
                    class: "th-separador",
                },
                {
                    text: "Filiais",
                    value: "filiais",
                    align: "center",
                    class: "th-separador",
                },
                {
                    text: "Custo",
                    value: "custo",
                    align: "center",
                    class: "th-separador min-width-100",
                },
                {
                    text: "Percentual (%)",
                    value: "percentual",
                    align: "center",
                    class: "th-separador",

                    width: "14%",
                },
                {
                    text: "Desconto (R$)",
                    value: "desconto",
                    align: "center",
                    class: "th-separador",

                    width: "14%",
                },
                {
                    text: "Justificativa",
                    value: "justificativas",
                    align: "center",
                    class: "th-separador",

                    width: "14%",
                },
                {
                    text: "Total de Desconto (R$)",
                    value: "total",
                    align: "center",
                    class: "th-separador",
                },
                {
                    text: "Investimento (R$)",
                    value: "investimento",
                    align: "center",
                    class: "th-separador",
                },
            ],
            money: {
                decimal: ",",
                thousands: ".",
                prefix: "",
                suffix: "",
                precision: 2,
                masked: false /* doesn't work with directive */,
            },
            carregando: false,
            semAcesso: false,
            mesDesconto: [],
            justificativas: [],
            primeiraAlteracao: true,
            precoFixoClonando: true
        };
    },
    computed: {
        mostrarPreAcordo() {
            if (this.acordo.idStatus === 30) {
                return true;
            }
            const data = this.$moment().format("YYYY-MM");
            if (!this.acordo.idStatus && data !== this.acordo.mesInicial) {
                return true;
            }
            return false;
        },

        mostraOverlay() {
            if (this.dialogoCamposFaltandoMensagem.length > 0) {
                return true;
            }
            return false;
        },
        somaNeogrupo() {
            const otc = parseFloat(this.neogrupo.perc_otc) || 0;
            const perf = parseFloat(this.neogrupo.perc_perfumaria) || 0;
            const rx = parseFloat(this.neogrupo.perc_rx) || 0;
            return Math.round((otc + perf + rx) * 100) / 100;
        },
        erroNeogrupoSoma() {
            const otc = this.neogrupo.perc_otc;
            const perf = this.neogrupo.perc_perfumaria;
            const rx = this.neogrupo.perc_rx;
            const algumPreenchido = (otc != null && otc !== '') || (perf != null && perf !== '') || (rx != null && rx !== '');
            if (!algumPreenchido) return false;
            return this.somaNeogrupo !== 100;
        },
    },
    methods: {
        investimentoClass() {
            // Retorna uma classe vazia ou lógica customizada se quiser
            return '';
        },
        calculaNeogrupoPreview() {
            // Stub para evitar erro, implemente a lógica real se necessário
            // Exemplo: this.neogrupoPreview = ...
        },
        showJustificativa(id_justificativa) {
            if(!id_justificativa) return ''
            const justificativa = this.justificativas.filter(item => {
                return item.id_justificativa == id_justificativa
            })
            return justificativa ? justificativa[0].justificativa : ''
        },  
        atualizaDescontos(item) {
            if (this.primeiraAlteracao) {
                for (const d of this.desconto) {
                    if (d.mes != item.mes && d.mes != "Total") {
                        d.desconto = item.desconto;
                        d.percentual = item.percentual;
                        d.justificativa = item.justificativa;
                    }
                }
            }
            this.calculaDesconto();
            this.primeiraAlteracao = false;
        },
        setSemAcesso(semAcesso) {
            this.semAcesso = semAcesso;
        },
        preAcordoFunc(currentValue) {
            console.log(" func pre acordo", currentValue);
            // this.$emit('preacordo', currentValue)
            this.$emit("update:preacordo", currentValue === true);
        },

        getPeriodo(campo = "quantidade") {
            var mesAtual = new Date(this.acordo.mesInicial + "-15");
            var mesFinal = new Date(this.acordo.mesFinal + "-15");

            var periodo = [];

            while (mesAtual <= mesFinal) {
                periodo.push(
                    campo +
                        "_" +
                        mesAtual.getFullYear() +
                        "_" +
                        (mesAtual.getMonth() + 1)
                );

                mesAtual.setMonth(mesAtual.getMonth() + 1);
            }

            return periodo;
        },
        getDesconto(periodo) {
            var mes =
                periodo.split("_")[1] +
                "-" +
                ("00" + periodo.split("_")[2]).substr(-2) +
                "-01";

            if (this.mesDesconto.length == 0) return 0;

            return this.mesDesconto.find((e) => e.mes.substr(0, 10) == mes)
                .desconto;
        },
        async criaDesconto(
            acordo,
            somaFiliais,
            somaFiliaisValor,
            quantidadeFiliais,
            errosFiliais
        ) {
            console.log(errosFiliais)

            if (quantidadeFiliais == 0 || (errosFiliais && errosFiliais.includes('erro_quantidade'))) {
                this.dialogoCamposFaltando = true;
                this.dialogoCamposFaltandoMensagem =
                    "Por favor selecione pelo menos uma filial para continuar";
                return;
            }
            if (errosFiliais && errosFiliais.includes('erro_regioes')) {
                this.dialogoCamposFaltando = true;
                this.dialogoCamposFaltandoMensagem =
                    "Há filiais escolhidas sem regiões";
                return;
            }

            this.dialogoCamposFaltando = false;
            this.dialogoCamposFaltandoMensagem = "";
            this.carregando = true;


            // Se os meses forem os mesmos, faz merge: atualiza só a coluna filiais, mantém os outros campos preenchidos
            let podeMerge = false;
            let descontoMerge = [];
            if (this.value && Array.isArray(this.value.valores) && this.value.valores.length > 0) {
                const valoresSalvos = this.value.valores.filter(v => v.mes !== 'Total');
                const mesesSalvos = valoresSalvos.map(v => v.mes);
                // Monta os meses atuais que serão exibidos na tabela
                const mesesAtuais = [];
                if (somaFiliais && somaFiliais[0]) {
                    for (const p of this.getPeriodo()) {
                        let data = p.split("_");
                        mesesAtuais.push(("0" + data[2]).slice(-2) + "/" + data[1]);
                    }
                }
                if (mesesSalvos.length === mesesAtuais.length && mesesSalvos.every((m, i) => m === mesesAtuais[i])) {
                    podeMerge = true;
                    // Faz o merge: atualiza só filiais
                    descontoMerge = valoresSalvos.map((linhaSalva, idx) => {
                        return {
                            ...linhaSalva,
                            filiais: somaFiliais[0][Object.keys(somaFiliais[0])[idx]]
                        };
                    });
                }
            }
            if (podeMerge) {
                // Adiciona linha de total
                const totalSalvo = this.value.valores.find(v => v.mes === 'Total');
                if (totalSalvo) {
                    descontoMerge.push({ ...totalSalvo, filiais: somaFiliais[0].total });
                }
                this.desconto = descontoMerge;
                this.primeiraAlteracao = false;
                this.carregando = false;
                this.calculaDesconto();
                return;
            }

            this.desconto = [];
            this.acordo = acordo;
            this.somaFiliais = somaFiliais;
            this.somaFiliaisValor = somaFiliaisValor;

            var data = {
                mesInicial: this.acordo.mesInicial + "-01",
                mesFinal: this.acordo.mesFinal + "-01",
                id_fornecedor: this.acordo.id_fornecedor,
            };

            this.mesDesconto = (
                await this.$http().post("/acordoCampanhaCircuito/mesDesconto", {
                    data: data,
                })
            ).data;

            try {
                const neogrupoResp = await this.$http().post("/acordoCampanhaCircuito/mesNeogrupo", {
                    data: data,
                });
                if (neogrupoResp.data && neogrupoResp.data.length > 0) {
                    const ng = neogrupoResp.data[0];
                    this.neogrupo.perc_otc = ng.perc_otc;
                    this.neogrupo.perc_perfumaria = ng.perc_perfumaria;
                    this.neogrupo.perc_rx = ng.perc_rx;
                } else {
                    this.alertaNeogrupoNull = true;
                }
            } catch (e) {
                this.alertaNeogrupoNull = true;
            }

            let descontosJustificativas = (
                await this.$http().post("/acordoCampanhaCircuito/justificativa")
            ).data;
            this.justificativas = descontosJustificativas.map((i) => {
                return {
                    justificativa: i.justificativa,
                    id_justificativa: i.id_justificativa,
                };
            });
            this.descontoCampo.percentual = null;
            this.descontoCampo.desconto = null;

            var desconto = [];
            var descontoMes = {};
            var descontoTotal = {};
            const usuario = this.$store.getters.getUsuario;
            const justificativaNegociacao = descontosJustificativas.find(
                (j) => j.id_justificativa == 1
            );
            descontoTotal.mes = "Total";
            descontoTotal.mes_desconto = null;
            descontoTotal.filiais = this.somaFiliais[0].total;
            descontoTotal.custo = null;
            descontoTotal.valor = 0;
            descontoTotal.desconto_padrao = null;
            descontoTotal.percentual = null;
            descontoTotal.desconto = null;
            descontoTotal.total = 0;
            descontoTotal.totalValor = 0;
            descontoTotal.investimento = 0;

            for (const p of this.getPeriodo()) {
                let data = p.split("_");

                descontoMes.mes = ("0" + data[2]).slice(-2) + "/" + data[1];
                descontoMes.mes_desconto = data[1] + "-" + data[2];
                descontoMes.filiais = this.somaFiliais[0][p];
                descontoMes.custo = null; // Editável pelo usuário
                descontoMes.valor = null;
                descontoMes.desconto_padrao = null; // Não traz mais padrão
                descontoMes.percentual = null; // Editável pelo usuário
                descontoMes.desconto = null; // Editável pelo usuário
                descontoMes.totalValor = null;
                descontoMes.total = '';
                descontoMes.justificativa = usuario.cargo == 'Cubo' ? justificativaNegociacao : '';
                descontoMes.investimentoValor = null;
                descontoMes.investimento = '';

                // Não soma nada nos totais, só será calculado quando usuário preencher
                desconto.push({ ...descontoMes });
            }

            descontoTotal.custo = descontoTotal.valor.toLocaleString("pt-br", {
                style: "currency",
                currency: "BRL",
            });
            descontoTotal.total = descontoTotal.total.toLocaleString("pt-br", {
                style: "currency",
                currency: "BRL",
            });
            descontoTotal.investimento =
                descontoTotal.investimento.toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                });

            desconto.push({ ...descontoTotal });
            this.desconto = desconto.map((a) => ({ ...a }));
            this.primeiraAlteracao = true;

            if (this.acordo.fnEditar) {
                let data = {};

                data.acordo = this.acordo;

                let response = await this.$http().post("/acordoCampanhaCircuito/desconto", {
                    data: data,
                });

                const descontoData = Array.isArray(response.data) ? response.data : response.data.desconto;

                for (let i = 0; i < descontoData.length; i++) {
                    this.desconto[i].desconto_padrao = this.isEspacoTela() ? 0 : descontoData[i].desconto_padrao;
                    this.desconto[i].percentual = this.isEspacoTela() ? 0 : descontoData[i].desconto_percentual;
                    this.desconto[i].desconto =  this.isEspacoTela() ? 0 : descontoData[i].desconto;
                    this.desconto[i].justificativa = descontoData[i].id_justificativa;
                    // Preenche o campo custo corretamente
                    this.desconto[i].custo = descontoData[i].custo ?? descontoData[i].valor ?? descontoData[i].valor_old ?? 0;
                }

                if (this.value.perc_otc != null || this.value.perc_perfumaria != null || this.value.perc_rx != null) {
                    this.neogrupo.perc_otc = this.value.perc_otc;
                    this.neogrupo.perc_perfumaria = this.value.perc_perfumaria;
                    this.neogrupo.perc_rx = this.value.perc_rx;
                    this.alertaNeogrupoNull = false;
                }
                this.primeiraAlteracao = false;
                this.calculaDesconto();
            } else {
                setTimeout(() => this.carregarDesconto(true), 100);
            }

            this.carregando = false;
        },
        isEspacoTela(){
            const is_espaco_macro_cluster_Tela = [
                "Tela"
            ];
            const result = is_espaco_macro_cluster_Tela.includes(this.value.espaco_macro) || this.value.isTelaSemana
            return result
        },
        carregarDesconto(isNovo = false) {
            for (const d of this.desconto) {
                const usuario = this.$store.getters.getUsuario;
                const percentualCampos = (isNovo && usuario.cargo == 'Cubo') ? 100 : this.descontoCampo.percentual;
                
                if (d.mes != "Total") {
                    d.percentual = percentualCampos;
                    d.desconto = this.descontoCampo.desconto;
                }
            }

            this.calculaDesconto();
        },
        calculosPrecosFixos (item) {
            if (this.precoFixoClonando) {
                if (this.desconto[0].mes == item.mes) {
                    const valor = item.valor
                    this.desconto = this.desconto.map(item => {
                        return {...item,valor:valor }
                    })
                } else {
                    this.precoFixoClonando = false
                }
                this.calculaDesconto() 
            }
        },
        calculaDesconto() {
            var descontoTotal = 0;
            var investimentoTotal = 0;

            for (const d of this.desconto) {
                if (d.mes != "Total") {
                    // Usa o campo custo (editável) como base
                    const custo = d.custo !== null && d.custo !== '' && !isNaN(parseFloat(d.custo)) ? parseFloat(d.custo) : 0;
                    const percentual = d.percentual !== null && d.percentual !== '' && !isNaN(parseFloat(d.percentual)) ? parseFloat(d.percentual) : 0;
                    const desconto = d.desconto !== null && d.desconto !== '' && !isNaN(parseFloat(d.desconto)) ? parseFloat(d.desconto) : 0;

                    d.totalValor = (custo * percentual) / 100 + desconto;
                    d.total = d.totalValor;
                    d.investimentoValor = Math.ceil(100 * (custo - d.totalValor)) / 100;
                    d.investimento = d.investimentoValor;

                    descontoTotal += d.totalValor;
                    investimentoTotal += d.investimentoValor;

                    d.total = d.totalValor.toLocaleString("pt-br", {
                        style: "currency",
                        currency: "BRL",
                    });
                    d.investimento = d.investimentoValor.toLocaleString("pt-br", {
                        style: "currency",
                        currency: "BRL",
                    });

                    if (
                        (percentual === 0 || percentual === "0" || percentual == undefined || percentual === "") &&
                        (desconto === 0 || desconto === "0" || desconto == undefined || desconto === "")
                    ) {
                        d.justificativa = "";
                    }
                }
            }

            this.desconto[this.desconto.length - 1].total =
                descontoTotal.toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                });
            this.desconto[this.desconto.length - 1].totalValor = descontoTotal;
            this.desconto[this.desconto.length - 1].investimento = (
                Math.ceil(100 * investimentoTotal) / 100
            ).toLocaleString("pt-br", { style: "currency", currency: "BRL" });

            // --- Sincroniza todos os dados de desconto para value.valores ---
            if (this.value && Array.isArray(this.value.valores)) {
                // Remove todos os itens
                this.value.valores.splice(0, this.value.valores.length);
                // Copia todos os itens atuais de desconto
                this.desconto.forEach((item) => {
                    this.value.valores.push({ ...item });
                });
            }

            this.calculaNeogrupoPreview();
        },
    },
};
</script>

<style>
.style-investimento-negativo {
    color: var(--v-error-base) !important;
}
.flag-pre-acordo {
    margin: 0 auto;
    padding-top: 0;
}
.flag-pre-acordo .v-label {
    color: #fff;
}
.flag-pre-acordo .v-input__slot {
    background: var(--v-yellow-base);
    padding: 7px 20px;
    border-radius: 6px;
    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
        0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
}
.input-neogrupo .v-input__slot {
    background: #fef1e0 !important;
}
</style>
